import { ExamAnswerResults } from "../../contracts/exam/dto"
import ProgressCircle from "../ProgressCircle";
import * as UI from './styled';
import scoreIcon from '../../assets/icons/graph_score.svg';
import medCoins from '../../assets/icons/med_coin.svg';
import { useDisplay } from "../../contexts/display";

type PropsDialogScoreExam = {
    answersExam: ExamAnswerResults;
}

const DialogScoreExam = ({ answersExam }: PropsDialogScoreExam) => {
    const { correct, score, answers, coins } = answersExam;
    const qtdAnswersExam = Object.values(answers).length;
    const percent = qtdAnswersExam > 0 ? (correct / qtdAnswersExam) * 100 : 0;
    const { isMobile } = useDisplay();

    return (
        <UI.Container style={{ gap: !isMobile ? 50 : 26 }}>
            <div className="element">
                <span>Acertos</span>
                <ProgressCircle percent={percent} size={6} fontSize={2} />
                <span>{correct} / {qtdAnswersExam}</span>
            </div>
            <div className="element">
                <span>Nota</span>
                <UI.Score width={6}>
                    <div className="score-content">
                        <img src={scoreIcon} alt="Score" />
                    </div>
                </UI.Score>
                <span>{score}</span>
            </div>
            <div className="element">
                <span>Medcoins</span>
                <img style={{ width: !isMobile ? '6rem' : '65px' }} src={medCoins} alt="Medcoins" />
                <span>{coins}</span>
            </div>
        </UI.Container>
    )
}

export default DialogScoreExam;